export default __webpack_public_path__ + "static/media/question.417eb0b0.png";